import {
  DeviceAsignScreenModel,
  DeviceLocationEnum
} from '@modules/digital-signage/model/devices.model';
import { DeviceGroupOption } from '@modules/digital-signage/model/device-groups.model';
import { MoveDevicesToGroupReqModel } from '@models/digital-signage/device-groups.model';
import { CallStateEnum } from '@shared/models/call-state.model';
import { CallStateMethods } from '@shared/store-features/call-state-feature';

export interface DeviceActionParams {
  data?: any;
  id?: any;
  state?: any;
  handleClose?: () => void;
}

export interface DeviceAsignScreenProps extends Omit<
  DeviceActionParams,
  'data'
> {
  data: DeviceAsignScreenModel;
}

export interface MoveDevicesToGroupParams {
  body: MoveDevicesToGroupReqModel;
  state: any;
  handleClose?: () => void;
}

export interface DeviceState extends CallStateMethods {
  callState: CallStateEnum;
  optionsCallState: CallStateEnum;
  screensData: any[];
  deviceGroupsData: DeviceGroupOption[];
  getScreens: () => void;
  getDeviceGroupsOptions: () => void;
  reloadDevices: (
    body: { ids: string[]; deviceLocation: DeviceLocationEnum },
    onSuccess?: () => void
  ) => void;
  deleteRow: (params: {
    data: { ids: string[]; deviceLocation: DeviceLocationEnum };
    state: any;
    handleClose?: () => void;
  }) => void;
  activateDeviceWithCode: (params: DeviceActionParams) => void;
  assignScreenDigitalSignageDevice: (params: DeviceAsignScreenProps) => void;
  moveDevicesToGroup: (params: MoveDevicesToGroupParams) => void;
  isOptionsLoading: () => boolean;
}

interface DeviceStateMethods {
  reloadDevices: 'reloadDevices';
  getScreens: 'getScreens';
  getDeviceGroupsOptions: 'getDeviceGroupsOptions';
  deleteRow: 'deleteRow';
  activateDeviceWithCode: 'activateDeviceWithCode';
  assignScreenDigitalSignageDevice: 'assignScreenDigitalSignageDevice';
  moveDevicesToGroup: 'moveDevicesToGroup';
  isOptionsLoading: 'isOptionsLoading';
}

export const DEVICES_INITIAL_STATE: Omit<
  DeviceStateMethods,
  keyof DeviceState
> = {
  screensData: [],
  deviceGroupsData: [],
  callState: CallStateEnum.Init,
  optionsCallState: CallStateEnum.Init
};
